import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import TemplateLibraryIcon from "../../assets/icons/template_rec.svg2";
import FiltersIcon from "../../assets/icons/filter.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import LibraryLinks from "./LibraryLinks";
import PageHeader from "../Common/PageHeader";
import TickListIcon from "../../assets/icons/tick_list.svg2";
import BroadcastIcon from "../../assets/icons/prod_broadcast.svg2";
import MyBadge from "../Common/MyBadge";
import MySearch from "../Common/MySearch";
import { proxyAPI } from "../proxyAPI";
import BroadcastTemplateDetails from "./BroadcastTemplateDetails";
import BroadcastTemplateCard from "./BroadcastTemplateCard";
import MyPagination from "../Common/MyPagination";
import DocumentLibraryIcon from "../../assets/icons/library_documents.svg2";
import LibraryIcon from "../../assets/icons/library_puzzle.svg2";
import Subheading from "../Common/Subheading";
import HelpButton from "../HelpContent/HelpButton";

export default function BroadcastTemplateLibrary() {
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [totalResults, setTotalResults] = useState(18);
  const [availableTemplates, setAvailableTemplates] = useState([]);
  const [status, setStatus] = useState("all");
  const [orderBy, setOrderBy] = useState("used-last");
  const [search, setSearch] = useState("");

  const loader = async (page = 0, perPage = 10) => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `broadcasters?search=${search}&orderBy=${orderBy}&status=${status}&offset=${
        page * perPage
      }&limit=${perPage}`,
    });
    setAvailableTemplates(data.data);
    setTotalResults(data.total);
    setSelectedTemplate(data.data[0]);
  };
  useEffect(() => {
    const timeOut = setTimeout(() => {
      loader();
    }, 500);

    return () => {
      clearTimeout(timeOut);
    };
  }, [search, orderBy, status]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <Subheading
            Icon={DocumentLibraryIcon}
            heading="Document Library"
            subheading="Access the documents stored and used across Logic."
          />
        </div>
        <div className="bg-white rounded-3 d-flex align-items-center p-3 gap-4 my-3">
          <div
            className="d-flex justify-content-center align-items-center bg-purple-gradient rounded-circle z-1"
            style={{ width: 40, height: 40 }}
          >
            <TickListIcon width={30} />
          </div>
          <div>
            <div className="fw-bold text-navy">
              Not sure which template you need?
            </div>
            <div className="text-secondary">
              Use this Wizard to help you choose a template.{" "}
            </div>
          </div>
          <div className="ms-4 me-3">
            <Button className="btn bg-colored-reverse rounded-pill py-2">
              <div className="d-flex align-items-center ">
                <h5 className="my-0 small px-1 fw-bold">HELP ME DECIDE</h5>
                <FontAwesomeIcon icon={faAngleRight} width={20} />
              </div>
            </Button>
          </div>
        </div>
      </div>

      <div className="mb-3 bg-colored-reverse rounded-3 p-3 d-flex justify-content-between">
        <div className="d-flex gap-2 align-items-center">
          <div className="">
            <FiltersIcon width={15} className="text-white" />
            <label className="fw-bold p-2 text-white">Filter options:</label>
            <Input
              isMulti
              onChange={() => null}
              value={["FILTER 1", "FILTER 2"]}
            />
          </div>
          <div>
            <label className="fw-bold p-2 text-white">Order by:</label>
            <Form.Select
              aria-label="newTemplate-select"
              onChange={(e) => {
                setOrderBy(e.target.value);
              }}
              value={orderBy}
            >
              <option value="created-last">Created Last</option>
              <option value="created-first">Created First</option>
              <option value="updated-first">Updated First</option>
              <option value="updated-last">Updated Last</option>
              <option value="used-last">Used Last</option>
              <option value="used-first">Used First</option>
            </Form.Select>
          </div>
          <div>
            <label className="fw-bold p-2 text-white">Status:</label>
            <Input
              value={[status]}
              onChange={(v) => {
                setStatus(v[0]);
              }}
              inputType="radio"
              options={[
                { value: "draft", label: "DRAFT" },
                { value: "published", label: "PUBLISHED" },
                { value: "archived", label: "ARCHIVED" },

                { value: "all", label: "ALL" },
              ]}
            />
          </div>
        </div>
      </div>
      <Row className="mb-5 my-3 ">
        <Col xs={12} lg={4} className="fw-bold pe-5">
          <span className="fs-3">
            {" "}
            Template Results <HelpButton helpKey="template-results" />
          </span>
          <MyBadge count={totalResults} />
          {availableTemplates.map((template) => (
            <BroadcastTemplateCard
              template={template}
              isSelected={selectedTemplate?.Uuid === template.Uuid}
              onSelect={() => setSelectedTemplate(template)}
            />
          ))}
          <MyPagination total={totalResults} onPaginate={loader} />
        </Col>
        <div className="col-lg-1"></div>

        <Col className="fw-bold">
          {selectedTemplate && (
            <>
              About this template:
              <BroadcastTemplateDetails selectedTemplate={selectedTemplate} />
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
